<template>
  <div class="quotes-section">
    <div class="quotes-inner">
      <!-- 左侧：标题 + 总资产 + 按钮 -->
      <div class="quotes-left">
        <h2 class="q-title">
          <span class="red">{{ $t("home.v2.quotes.title1") }}</span>
          <span class="dark">{{ $t("home.v2.quotes.title2") }}</span>
        </h2>
        <p class="q-desc">{{ $t("home.v2.quotes.desc") }}</p>

        <!-- <div class="q-assets" v-if="isLogin">
          <p class="q-assets-label">
            {{ $t("home.v2.quotes.totalAssets") }}
            <img
              v-if="showAssets"
              @click="showAssets = !showAssets"
              src="@/assets/img/images/home/eye.png"
              alt=""
              srcset=""
            />
            <img
              v-else
              @click="showAssets = !showAssets"
              src="@/assets/img/images/home/eye2.png"
              alt=""
              srcset=""
            />
          </p>
          <p class="q-assets-amount">
            <span class="amount-num">{{ showAssets ? totalAssetsDisplay : "******" }}</span>
            <span class="currency-selector" @click.stop="toggleCurrencyPicker">
              <span class="unit">{{ legalCurrency }}</span>
              <i class="el-icon-caret-bottom" />
              <div class="currency-dropdown" v-if="showCurrencyPicker">
                <div
                  class="currency-option"
                  :class="{ active: legalCurrency === 'HKD' }"
                  @click.stop="selectCurrency('HKD')"
                >HKD</div>
                <div
                  class="currency-option"
                  :class="{ active: legalCurrency === 'USD' }"
                  @click.stop="selectCurrency('USD')"
                >USD</div>
              </div>
            </span>
          </p>
          <p class="q-pnl">
            {{ $t("home.v2.quotes.todayPnl") }}
            <span class="pnl-value" :style="{ color: pnlColor }">{{ pnlValueDisplay }}</span>
            <span class="pnl-rate" :style="{ color: pnlColor }">{{ pnlRateDisplay }}</span>
          </p>
        </div> -->

        <div class="q-btns">
          <div class="q-btn q-btn-primary" @click="$router.push('/wallet')">
            {{ $t("home.v2.quotes.viewManage") }}
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="q-btn q-btn-plain" @click="$router.push('/partner')">
            {{ $t("home.v2.quotes.partner") }}
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>

      <!-- 右侧：行情列表 -->
      <div class="quotes-right">
        <div class="q-right-head">
          <div class="q-tabs">
            <template v-for="(item, index) in symbolList">
              <span
                v-if="item.baseSymbol !== $t('trade_ctc.header.self')"
                :key="index"
                :class="['q-tab', { active: coinFilter.listIndex === index }]"
                @click="coinListChange(index)"
              >
                {{ usdt2Usd(item.baseSymbol) }}
              </span>
            </template>
          </div>
          <div class="q-view-all" @click="tableShowMore">
            {{ $t("home.v2.quotes.viewAll") }}
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <div class="q-list">
          <div
            class="q-row"
            v-for="(row, index) in displayList"
            :key="index"
            @click="jumpToMarket(row)"
          >
            <div class="q-coin">
              <img
                v-if="row.icon"
                class="q-coin-icon"
                :src="row.icon"
                alt="coin"
              />
              <span v-else class="q-coin-icon q-coin-placeholder"></span>
              <span class="q-coin-name">{{ row.s.split("/")[0] }}</span>
            </div>
            <div class="q-price">
              {{ getFloorNum(row.c, getSymbolPrecision(row.s, "price")) }}
              <span class="q-price-unit">{{
                usdt2Usd(row.s.split("/")[1])
              }}</span>
            </div>
            <div
              class="q-change"
              :style="{ color: row.p >= 0 ? '#52C18E' : '#F04545' }"
            >
              {{ row.p >= 0 ? "+" : ""
              }}{{ getFloorNumAndComplemented(row.p * 100, 2) }}%
            </div>
          </div>
          <div v-if="displayList.length === 0" class="q-empty">--</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import precisionMixin from "@/mixins/precisionMixin";

export default {
  name: "QuotesSection",
  mixins: [precisionMixin],
  data() {
    return {
      showAssets: true,
      socket: null,
      pingTime: 0,
      socketTimer: null,
      allMarketData: null, // 所有交易对行情
      originalSymbol: [], // 接口获取的原始交易对信息
      symbolList: [], // 所有交易对（含自选占位）
      coinTable: [], // 当前 tab 下的交易对
      coinFilter: {
        listIndex: 1,
      },
      totalAssetCurrency: "",
      legalCurrency: "HKD",
      showCurrencyPicker: false,
      pnlData: null, // 盈亏数据
    };
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
    // 右侧只展示前 6 条
    displayList() {
      return this.coinTable.slice(0, 6);
    },
    isLogin() {
      return !!(this.user.username && window.localStorage.getItem("jwt-token"));
    },
    totalAssetsDisplay() {
      // if (!this.isLogin) return "******";
      if (this.totalAssetCurrency === "" || this.totalAssetCurrency == null) {
        return "--";
      }
      return this.totalAssetCurrency;
    },
    // 盈亏额显示：+5,800.50 / -5,800.50 / 0.00
    pnlValueDisplay() {
      if (!this.pnlData) return "--";
      const val = Number(this.pnlData.profitValue || 0);
      const formatted = Math.abs(val).toFixed(2);
      const prefix = formatted >= 0 ? "+" : "-";
      return prefix + formatted + " " + this.legalCurrency;
    },
    // 盈亏比例显示：+4.83% / -4.83% / --
    pnlRateDisplay() {
      if (!this.pnlData) return "--";
      if (this.pnlData.profitRate == null) return "--";
      const val = Number(this.pnlData.profitRate);
      const prefix = val > 0 ? "+" : "";
      return prefix + val.toFixed(2) + "%";
    },
    // 盈亏颜色：涨绿、跌红、0灰
    pnlColor() {
      if (!this.pnlData) return "#999999";
      const val = Number(this.pnlData.profitValue || 0);
      const formatted = Math.abs(val).toFixed(2);
      if (formatted >= 0) return "#52C18E";
      if (formatted < 0) return "#F04545";
      return "#999999";
    },
  },
  created() {
    this.getWebsocket();
    this.webSocketWatch();
    if (this.isLogin) {
      this.getTotalAssets();
      this.getProfitLoss();
    }
    // 点击页面任意位置关闭币种下拉
    document.addEventListener("click", this.closeCurrencyPicker);
  },
  beforeDestroy() {
    clearInterval(this.socketTimer);
    if (this.socket) {
      this.socket.close();
    }
    document.removeEventListener("click", this.closeCurrencyPicker);
  },
  methods: {
    toggleCurrencyPicker() {
      this.showCurrencyPicker = !this.showCurrencyPicker;
    },
    closeCurrencyPicker() {
      this.showCurrencyPicker = false;
    },
    selectCurrency(currency) {
      if (this.legalCurrency === currency) {
        this.showCurrencyPicker = false;
        return;
      }
      this.legalCurrency = currency;
      this.showCurrencyPicker = false;
      // 切换币种后重新拉取总资产和盈亏
      if (this.isLogin) {
        this.totalAssetCurrency = "";
        this.pnlData = null;
        this.getTotalAssets();
        this.getProfitLoss();
      }
    },
    usdt2Usd(token) {
      if (token) {
        return token.replace("T", "");
      }
      return token;
    },
    // 获取总资产
    getTotalAssets() {
      this.$axios
        .post("/userAssets/queryAssetList", {
          accountType: "spot",
          legalCurrency: this.legalCurrency,
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.totalAssetCurrency = res.data.data.totalAssetCurrency;
          }
        });
    },
    // 获取今日盈亏
    getProfitLoss() {
      this.$axios
        .post("/userAssets/assetProfitLoss", {
          legalCurrency: this.legalCurrency,
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.pnlData = res.data.data || null;
          }
        })
        .catch(() => {
          this.pnlData = null;
        });
    },
    // websocket 心跳计时
    webSocketWatch() {
      let that = this;
      this.socketTimer = setInterval(function () {
        that.pingTime = that.pingTime + 5;
      }, 5000);
    },
    // 跳转行情页
    jumpToMarket(row) {
      this.$router.push({ path: "/ctc", query: { symbol: row.s } });
    },
    tableShowMore() {
      this.$router.push({ path: "/ctc" });
    },
    // 切换 tab
    coinListChange(index) {
      this.coinFilter.listIndex = index;
      if (this.symbolList.length > 0 && index < this.symbolList.length) {
        this.coinTable = this.symbolList[index].coinSymbols;
      }
    },
    getWebsocket() {
      let that = this;
      let Socket = new WebSocket(
        this.$axios.defaults.baseWS +
          "/ws/client/h5/" +
          (this.user.userId ? this.user.userId : 99000000),
      );
      this.socket = Socket;
      let tickerStr = "market.ticker";
      Socket.onopen = function () {
        Socket.send(JSON.stringify({ sub: tickerStr }));
      };
      Socket.onmessage = function (res) {
        let retData = JSON.parse(res.data);
        if (retData.ping) {
          that.pingTime = 0;
          Socket.send(JSON.stringify({ pong: retData.ping }));
        } else if (retData.sub === tickerStr) {
          if (!that.allMarketData) {
            that.allMarketData = retData.data;
            that.getSymbolList();
          } else {
            for (let key in retData.data) {
              if (that.allMarketData.hasOwnProperty(key)) {
                that.allMarketData[key] = retData.data[key];
              } else {
                that.$set(that.allMarketData, key, retData.data[key]);
              }
            }
            that.getAllCoinMarket(that.originalSymbol);
            that.coinListChange(that.coinFilter.listIndex);
          }
        }
      };
      Socket.onclose = function () {};
    },
    // 整理拼接展示交易对
    getAllCoinMarket(symbolList) {
      let that = this;
      this.symbolList = this.deepCopy(symbolList);
      // 头部插入空自选列表
      this.symbolList.unshift({
        baseSymbol: that.$t("trade_ctc.header.self"),
        coinSymbols: [],
      });
      for (let i = 1; i < that.symbolList.length; i++) {
        let baseSymbol = that.symbolList[i].baseSymbol;
        let coinList = that.symbolList[i].coinSymbols;
        let newCoinList = [];
        for (let j = 0; j < coinList.length; j++) {
          let symbol = coinList[j].coinSymbol + "/" + baseSymbol;
          if (that.allMarketData.hasOwnProperty(symbol)) {
            that.$set(that.allMarketData[symbol], "icon", coinList[j].icon);
            newCoinList.push(that.allMarketData[symbol]);
          }
        }
        that.symbolList[i].coinSymbols = newCoinList;
      }
    },
    // 获取所有交易对
    getSymbolList() {
      this.$axios.post("/exchangeCoin/getAll", {}).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.originalSymbol = res.data.data.symbolArray;
          this.getAllCoinMarket(this.originalSymbol);
          this.coinListChange(this.coinFilter.listIndex);
        }
      });
    },
  },
  watch: {
    pingTime() {
      if (this.pingTime >= 30) {
        this.socket.close();
        this.getWebsocket();
        this.pingTime = 0;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.quotes-section {
  width: 100%;
  box-sizing: border-box;
  padding: 80px 60px;
  background: #f6f7f9;
}
.quotes-inner {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.quotes-left {
  flex: 1;
  max-width: 1000px;
  .q-title {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: clamp(32px, 2.75vw, 60px);
    line-height: 1.35;
    white-space: nowrap;
    .red {
      color: #e05807;
    }
    .dark {
      color: #333333;
      margin-left: 8px;
    }
  }
  .q-desc {
    margin-top: 12px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 22px;
    color: #333333;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
  }
  .q-assets {
    margin-top: 24px;
    .q-assets-label {
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 26px;
      color: #1f2329;
      display: flex;
      align-items: center;
      img {
        cursor: pointer;
        width: 24px;
        height: 24px;
        margin-left: 22px;
      }
    }
    .q-assets-amount {
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 52px;
      color: #1f2329;
      display: flex;
      align-items: baseline;
      .amount-num {
        line-height: 1;
      }
      .unit {
        font-family: PingFang SC, PingFang SC;
        font-weight: 800;
        font-size: 26px;
        color: #1f2329;
        margin-left: 8px;
        line-height: 1;
      }
      .currency-selector {
        display: inline-flex;
        align-items: center;
        margin-left: 4px;
        cursor: pointer;
        position: relative;
        .el-icon-caret-bottom {
          font-size: 16px;
          color: #1f2329;
          margin-left: 4px;
        }
        .currency-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          margin-top: 4px;
          background: #ffffff;
          border: 1px solid #dcdbd9;
          border-radius: 6px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          z-index: 999;
          min-width: 80px;
          overflow: hidden;
        }
        .currency-option {
          padding: 8px 16px;
          font-size: 14px;
          color: #333333;
          cursor: pointer;
          transition: background 0.2s;
          &:hover {
            background: #f5f5f5;
          }
          &.active {
            color: #e05807;
            font-weight: 600;
          }
        }
      }
    }
    .q-pnl {
      margin-top: 12px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 26px;
      color: #1f2329;
      .pnl-value {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 26px;
        color: #2ebd85;
        margin-left: 26px;
      }
      .pnl-rate {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 26px;
        color: #2ebd85;
        margin-left: 4px;
      }
    }
  }
  .q-btns {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-top: 40px;
    .q-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 48px;
      padding: 0 24px;
      cursor: pointer;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 15px;
      border-radius: 6px;
      transition: all 0.2s;
      i {
        margin-left: 8px;
        font-size: 13px;
      }
    }
    .q-btn-primary {
      background: #e05807;
      color: #ffffff;
      &:hover {
        background: #a02b2d;
      }
    }
    .q-btn-plain {
      color: #e05807;
      border: 1px solid #e05807;
      &:hover {
        background: rgba(224, 88, 7, 0.06);
      }
    }
  }
}
.quotes-right {
  flex: 1;
  max-width: 660px;
  .q-right-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .q-tabs {
      display: flex;
      align-items: center;
      gap: 28px;
      .q-tab {
        position: relative;
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 28px;
        color: #787878;
        &.active {
          color: #333333;
          font-weight: 600;
        }
        &.active::before {
          content: "";
          display: block;
          width: 50%;
          height: 4px;
          background: #e05807;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: -8px;
        }
      }
    }
    .q-view-all {
      cursor: pointer;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #666666;
      i {
        margin-left: 4px;
      }
      &:hover {
        color: #333333;
      }
    }
  }
  .q-list {
    margin-top: 30px;
    .q-row {
      display: flex;
      align-items: center;
      padding: 15px 6px;
      cursor: pointer;
      transition: background 0.2s;
      &:hover {
        background: #eef0f2;
      }
      .q-coin {
        flex: 1;
        display: flex;
        align-items: center;
        .q-coin-icon {
          width: 44px;
          height: 44px;
          margin-right: 12px;
        }
        .q-coin-placeholder {
          background: #eef0f2;
        }
        .q-coin-name {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 20px;
          color: #333333;
        }
      }
      .q-price {
        flex: 1;
        text-align: right;
        padding-right: 50px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 20px;
        color: #333333;
        .q-price-unit {
          font-size: 16px;
          color: #333333;
          margin-left: 4px;
        }
      }
      .q-change {
        width: 110px;
        text-align: right;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 20px;
      }
    }
    .q-empty {
      text-align: center;
      padding: 40px 0;
      color: #b0b4bd;
    }
  }
}
</style>
